/**
 * Checks if a date (string | null) is within the optional range [start, end].
 * - If neither start nor end exists, returns true.
 * - If dateStr is null and there is at least one bound, returns false.
 */
export function matchesDateRange(
  dateStr: string | null,
  start: string | null,
  end: string | null,
): boolean {
  if (!start && !end) return true; // no filter → always ok
  if (!dateStr) return false; // missing field → no match
  const date = new Date(dateStr);
  if (start && date < new Date(start)) return false;
  if (end && date > new Date(end)) return false;
  return true;
}
